import { AvailableModules, Features } from 'generated/featureDefinitions'

import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { RequestUpgradeProps } from 'modules/upsell/lib/requestUpgradeTypes'

export type UpsellSourceType =
  | 'ap_bankaccounts_upsellcard'
  | 'ap_finance_upsellcard'
  | 'ap_itmanagement_upsellcard'
  | 'ap_expenses_upsellcard'
  | 'ap_procurement_upsellcard'
  | 'ap_banking_upsellcard'
  | 'ap_finance_overview_upsell_card'
  | 'ap_accounting_overview_upsell_card'
  | 'ap_treasury_overview_upsell_card'

export const missingAddonUpsellRequestProps = (
  source: UpsellSourceType,
  moduleRequested: AvailableModules,
  featureRequested: Features
) => {
  const featureToRequest: RequestUpgradeProps = {
    moduleRequested: moduleRequested,
    featureRequested: featureRequested,
    requestSource: source,
    requestReason: ValidReasons.MissingAddon,
  }

  return featureToRequest
}

export const accountsPayableUpsellRequestProps = (source: UpsellSourceType) => {
  return missingAddonUpsellRequestProps(
    source,
    AvailableModules.accounts_payable,
    Features.accounts_payable_management
  )
}
